"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiMoney = _interopRequireDefault(require("ui-money"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var toDollar = function toDollar(number) {
  return new _uiMoney.default(number, 'USD').format(0);
};
var InvalidRevisionAmount = function InvalidRevisionAmount(_ref) {
  var changeAmount = _ref.changeAmount,
    className = _ref.className,
    minMasschusettesAmt = _ref.minMasschusettesAmt,
    minAmount = _ref.minAmount,
    maxAmount = _ref.maxAmount,
    isMA_FRPLoan = _ref.isMA_FRPLoan,
    hasValidOffers = _ref.hasValidOffers;
  if (hasValidOffers) return null;
  var message = "Please enter an amount between ".concat(toDollar(minAmount), " and ").concat(toDollar(maxAmount));
  if (isMA_FRPLoan) {
    message = changeAmount < minMasschusettesAmt ? "".concat(toDollar(minMasschusettesAmt), " is the minimum Fixed Rate Plan amount in Massachusetts") : "Please enter an amount between ".concat(toDollar(minMasschusettesAmt), " and ").concat(toDollar(maxAmount));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "revision-validation ".concat(className)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "revision-validation--error"
  }, message));
};
InvalidRevisionAmount.propTypes = {
  changeAmount: _propTypes.default.number,
  className: _propTypes.default.string,
  minMasschusettesAmt: _propTypes.default.number,
  minAmount: _propTypes.default.string,
  maxAmount: _propTypes.default.string,
  isMA_FRPLoan: _propTypes.default.bool,
  hasValidOffers: _propTypes.default.bool
};
var _default = InvalidRevisionAmount;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions/dist/pf-revisions.scss');